import { createSelector } from 'reselect';

const selectForumGroups = (state: any) => state.forumGroups;


export const selectForumGroupsCurrentItem = createSelector([selectForumGroups], (forumGroups) => forumGroups.current);

export const selectForumGroupsListItems = createSelector([selectForumGroups], (forumGroups) => forumGroups.list);

export const selectForumGroupsItemById = (itemId: any) =>
    createSelector(selectForumGroupsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectForumGroupsQueryItems = createSelector([selectForumGroups], (forumGroups) => forumGroups.query);

export const selectForumGroupsCreatedItem = createSelector([selectForumGroups], (forumGroups) => forumGroups.create);

export const selectForumGroupsUpdatedItem = createSelector([selectForumGroups], (forumGroups) => forumGroups.update);

export const selectForumGroupsReadItem = createSelector([selectForumGroups], (forumGroups) => forumGroups.read);

export const selectForumGroupsDeletedItem = createSelector([selectForumGroups], (forumGroups) => forumGroups.delete);

export const selectForumGroupsSearchedItems = createSelector([selectForumGroups], (forumGroups) => forumGroups.search);

export const selectForumGroupsItemsCount = createSelector([selectForumGroups], (forumGroups) => forumGroups.count);

export const selectForumGroupsItemsFilter = createSelector([selectForumGroups], (forumGroups) => forumGroups.filter);